import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "@/lib/analytics";

/**
 * Mounts once at the app root and fires a pageview whenever the pathname
 * changes. Safe to include on every route including /admin — the tracker
 * itself never blocks the UI.
 */
export function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    // Small delay lets react-helmet-async set the title before the beacon sends.
    const id = setTimeout(() => trackPageview(), 30);
    return () => clearTimeout(id);
  }, [location.pathname]);
  return null;
}
